import generateTicks from './generate-ticks';
export default generateTicks;
